<div [class.not-show-learn-data] = "!showLearnData">
  <div class="ai-btn-wrapper">
    <div>
      &nbsp;
      <button [disabled]="gptInWorking" *ngIf="!gptInWorking" style="width: 100px;" [matMenuTriggerFor]="startMenu" mat-raised-button color="warn">Start</button>
      <button *ngIf="gptInWorking" style="width: 100px;" (click)="gptStop()" mat-raised-button color="warn">Stop</button>
      &nbsp;
      <button (click)="showLearnData = !showLearnData" mat-raised-button color="primary">Show/Hide Learn Data</button>
      &nbsp;
      <button [disabled]="disableTuneFileBtn" style="background-color: #cba12e" (click)="getFineTuneFile()" mat-raised-button color="primary">Tune file</button>
      &nbsp;
      <button [disabled]="disableCompareFileBtn" style="background-color: #794bbb" (click)="getCompareFile()" mat-raised-button color="primary">Compare file</button>
      &nbsp;
      <button style="background-color: #30c242" (click)="showTreeData()" mat-raised-button color="primary">Tree</button>
      &nbsp;
      <button style="background-color: #14a19c" (click)="getGptLastUpdate()" mat-raised-button color="primary">Last GPT update results</button>
      &nbsp;
<!--      <button (click)="filterReset()" mat-raised-button>Reset All Filters</button>-->
      <button matTooltip="Clear All Filters" (click)="filterReset()" mat-icon-button>
        <mat-icon>layers_clear</mat-icon>
      </button>

      <button matTooltip="Random products" [disabled]="true" (click)="getRandomProducts()" mat-icon-button>
        <mat-icon>refresh</mat-icon>
      </button>
      <button style="float: right;" matTooltip="Settings" [disabled]="true" (click)="aiSettings()" mat-icon-button>
        <mat-icon>settings</mat-icon>
      </button>

      <mat-menu class="primary" #startMenu="matMenu">
        <button (click)="parserSelected()" mat-menu-item>Selected <span *ngIf="selectedItemsCount"> ({{selectedItemsCount}})</span></button>
        <button (click)="parserFilered()" mat-menu-item>Filtered</button>
      </mat-menu>
    </div>
  </div>
  <ag-grid-angular
    class="ag-theme-balham ai-fine-tuning-main"
    [serverSideInfiniteScroll]="true"
    [pagination]="true"
    [paginationPageSize]="5000"
    [cacheBlockSize]="100"
    [maxBlocksInCache]="20"
    [maxConcurrentDatasourceRequests]="3"
    [getContextMenuItems]="getContextMenuItems"
    [sideBar]="sideBar"
    [statusBar]="statusBar"
    [rowSelection]="'multiple'"
    [rowGroupPanelShow]="'never'"
    [pivotPanelShow]="'always'"
    [autoGroupColumnDef]="autoGroupColumnDef"
    [enableRangeSelection]="false"
    [rowModelType]="'serverSide'"
    [columnDefs]="columnDefs"
    [suppressCopyRowsToClipboard]="true"
    [defaultColDef]="defaultColDef"
    [animateRows]="false"
    [suppressRowClickSelection]="false"
    [enableCellChangeFlash]="true"
    [stopEditingWhenCellsLoseFocus]="false"
    (gridReady)="onGridReady($event)"
    (selectionChanged)="onSelectionChanged($event)"
    (filterChanged)="filterChanged($event)"
  ></ag-grid-angular>
  <ag-grid-angular
    class="ag-theme-balham ai-fine-tuning-gpt-results"
    [serverSideInfiniteScroll]="true"
    [pagination]="true"
    [paginationPageSize]="5000"
    [cacheBlockSize]="5000"
    [maxBlocksInCache]="10"
    [maxConcurrentDatasourceRequests]="3"
    [getContextMenuItems]="getGptContextMenuItems"
    [sideBar]="sideBar"
    [statusBar]="statusBar"
    [rowSelection]="'multiple'"
    [rowGroupPanelShow]="'never'"
    [pivotPanelShow]="'always'"
    [autoGroupColumnDef]="autoGroupColumnDef"
    [enableRangeSelection]="false"
    [rowModelType]="'serverSide'"
    [columnDefs]="columnDefsGptResult"
    [suppressCopyRowsToClipboard]="true"
    [defaultColDef]="defaultColDef"
    [animateRows]="true"
    [suppressRowClickSelection]="false"
    [enableCellChangeFlash]="true"
    [stopEditingWhenCellsLoseFocus]="false"
    (gridReady)="onGptResultGridReady($event)"
    (selectionChanged)="onSelectionChanged($event)"
    (filterChanged)="filterChanged($event)"
  ></ag-grid-angular>
  <ag-grid-angular
    *ngIf="showLearnData"
    class="ag-theme-balham ai-fine-tuning-learn-data"
    [serverSideInfiniteScroll]="true"
    [pagination]="true"
    [paginationPageSize]="5000"
    [cacheBlockSize]="500"
    [maxBlocksInCache]="10"
    [maxConcurrentDatasourceRequests]="3"
    [statusBar]="statusBar"
    [rowSelection]="'multiple'"
    [rowGroupPanelShow]="'never'"
    [rowClassRules]="rowClassRules"
    [pivotPanelShow]="'always'"
    [autoGroupColumnDef]="autoGroupColumnDef"
    [enableRangeSelection]="false"
    [rowModelType]="'serverSide'"
    [getContextMenuItems]="getLearnDataContextMenuItems"
    [columnDefs]="columnDefsLearnFields"
    (cellValueChanged)="cellValueChanged($event)"
    [suppressCopyRowsToClipboard]="true"
    [defaultColDef]="defaultColDef"
    [animateRows]="false"
    [suppressRowClickSelection]="false"
    [enableCellChangeFlash]="true"
    [stopEditingWhenCellsLoseFocus]="false"
    (gridReady)="onLearnDataGridReady($event)"
    (selectionChanged)="onSelectionChanged($event)"
    (filterChanged)="filterChanged($event)"
  ></ag-grid-angular>
</div>

